export { Accordion } from './Accordion';
export { AccordionContent } from './components/AccordionContent';
export { AccordionControls } from './components/AccordionControls';
export { AccordionGroup } from './components/AccordionGroup';
export { AccordionHeader } from './components/AccordionHeader';
export {
  AccordionEventHandler,
  useAccordionController,
  AccordionEventContext,
} from './AccordionEventHandler';

export const AccordionEvent = {
  OPEN: Symbol('Accordion.Open'),
  CLOSE: Symbol('Accordion.Close'),
  SET_OPEN: Symbol('Accordion.Set_Open'),
  IS_OPEN: Symbol('Accordion.Is_Open'),
};

export type AccordionSubscriber = {
  element: any;
  reducer: (type: symbol, value?: boolean, noAnimate?: boolean) => boolean;
};
